import { makeStyles } from '@material-ui/core';

const drawerWidthOpen = 260;
const drawerWidthClose = 52;
export const useNavigationStyle = makeStyles(theme => ({
  root: {
    display: 'flex'
  },

  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    zIndex: 99,
    width: drawerWidthOpen,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    border: '0 !important',
    '& .MuiPaper-root':{
      background: theme.palette.primary.dark,
      color: 'white',
    }
  },
  drawerOpen: {
    // top: '69px !important',
    borderRight: 0,
    boxShadow: '0 4px 24px 0 rgb(34 41 47 / 10%)',
    paddingTop: '1rem',
    overflowX: 'hidden',
    width: drawerWidthOpen,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    // top: '69px !important',

    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: drawerWidthClose,
    '& h6': {
      marginLeft: '11px !important'
    },
    '& .MuiListItem-button':{
      marginLeft: '-5px'
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    height: '23px'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  footer: {
    position: 'fixed',
    display: 'flex',
    bottom: 0,
    flexDirection: 'column'
  },
  footerOpen: {
    width: drawerWidthOpen,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  footerClose: {
    width: drawerWidthClose,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  footerWrapperButton: {
    alignSelf: 'flex-end',
    height: '60px',
    color: 'white',
    '& .MuiButtonBase-root': {
      color: 'white'
    }
  },
  appBar: {
    background: theme.palette.secondary.light,
    filter: 'drop-shadow(0px 1px 10px rgba(74, 86, 109, 0.05))'
  },
  hgtagFlowsLogoNoText: {
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    textAlign: 'center',
    paddingTop: '0.5rem',
    height: '2.5rem',
    marginBottom: '1rem'
  },
  hgtagLogo:{
    cursor: 'pointer',
    textAlign: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(7)
  }
}));
